// extracted by mini-css-extract-plugin
export default {"Footer":"styles_Footer__364DX"};